import React from 'react';
import SortBy, {
  SortByItemType,
} from '@/pages/intelligence/components/TableComponents/components/SortBy';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import { valueFormat, growthFormat } from '@/pages/intelligence/utils/commonUtils';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { RenderType } from '@/pages/intelligence/pages/_config/topchartsInterface';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';

interface RankCloumsType {
  key: string;
  title: string;
  currentSortKey: string;
  currentSortValue: string; // '' | 'desc' | 'asc';
  onSortChage: (e: SortByItemType) => void;
  sortMetric: string;
  textContent: string;
  tipText?: React.ReactNode;
  width?: number;
  renderType: RenderType;
  onlySimpleSort: boolean;
  isNoDropdown?: boolean;
  getMetricValueOfCvm: (cvm: any, metricKey: string) => any;
}

export const RankCloums = (params: RankCloumsType) => {
  const {
    key,
    title: titleKey,
    textContent: textContentKey,
    tipText: tipTextKey,
    sortMetric,
    currentSortKey,
    currentSortValue,
    onSortChage,
    renderType,
    width = 180,
    onlySimpleSort,
    isNoDropdown,
    getMetricValueOfCvm = () => console.log,
  } = params;
  const { formatMessage } = useIntlExtend();
  const title = typeof titleKey === 'string' ? formatMessage({ id: titleKey }) : titleKey;
  const tipText = typeof tipTextKey === 'string' ? formatMessage({ id: tipTextKey }) : tipTextKey;

  return {
    key,
    width,
    value: key,
    align: 'center',
    header: () => {
      /** 当不是环比排序时，表格标题文本有提示文本 */
      const showTextBubble = currentSortKey !== `${key}_1`;
      return (
        <CloumsCenter width={width} align={'right'}>
          <SortBy
            align={'right'}
            title={title}
            defaultKey={currentSortKey}
            defaultValue={currentSortValue}
            // svgIcon={getDataSourceIcon(dataSource)}
            onlySimpleSort={onlySimpleSort}
            isNoDropdown={isNoDropdown}
            list={
              [RenderType.GROWTH_ONLY, RenderType.VALUE_ONLY].includes(renderType)
                ? [
                    {
                      key: `${key}_0`,
                      sortMetric,
                      // orderSource: dataSource,
                      text: title,
                      title,
                      ratioType: 0,
                    },
                  ]
                : [
                    {
                      key: `${key}_0`,
                      sortMetric,
                      // orderSource: dataSource,
                      text: title,
                      title,
                      ratioType: 0,
                    },
                    {
                      key: `${key}_1`,
                      sortMetric,
                      // orderSource: dataSource,
                      text: `${title}:${formatMessage({ id: 'dbi_change' })}(%)`,
                      title: title?.indexOf('$') > -1 ? `${title}%` : `${title}(%)`, // title === 'Revenue($)' ? 'Revenue($)%' : `${title}(%)`,
                      ratioType: 1,
                    },
                  ]
            }
            onChange={onSortChage}
            content={
              tipText
              // showTextBubble &&
              // (textContent || tipText) && (
              //   <>
              //     {textContent} <br /> {tipText}
              //   </>
              // )
            }
            // content={showTextBubble && textContent}
            // tipText={tipText}
          />
        </CloumsCenter>
      );
    },
    render: (cvm: any) => {
      // const metrics = cvm?.metrics || [];
      // const metric = metrics.find((item: any) => {
      //   return item?.metric === key;
      // });
      const metric = getMetricValueOfCvm(cvm, key);
      const value = valueFormat(metric?.value);
      const growthDataObj = growthFormat({
        value: metric?.growth_ratio,
        valueType: 'rankValue',
        hasPoint: 'none',
        fixedNum: 0,
        maxNumber: 999,
        zeroValue: '=',
      });
      return (
        <CloumsCenter width={width} align={'center'}>
          <TableShowData
            maxNumber={'999+'}
            value={value}
            type={growthDataObj?.type}
            growth={growthDataObj?.value}
          />
        </CloumsCenter>
      );
    },
  };
};
